import {Component, Input, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import { IconService } from '../../services/icon.service';
import { AccountService } from '../../services/account.service';
import { BrokerService } from 'services/broker.service';
import { EventEmitterService } from 'services/event-emitter.service';
import {environment} from "../../environments/environment";

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {
  menuOpen: boolean;
  @Input()
  isResident: boolean = false;
  isBroker: boolean = false;
  smartHomeMarketingUrl : string = environment.SmartHome.MarketingUrl;

  constructor(
    private router: Router,
    private IconService: IconService,
    private accountService: AccountService,
    private brokerService: BrokerService,
    private eventEmitterService: EventEmitterService
  ) {
    this.brokerService.getBroker().subscribe(res => {
      if(res != null){
        this.isBroker = true;
      }
    });
    this.eventEmitterService.brokerChangeEmitted$.subscribe(res => this.isBroker = res);
   }

  ngOnInit() {
    this.IconService.registerIcons();
  }
  getResidentStatus() {
    this.accountService.getResidentStatus()
    .subscribe(res => this.onGetResidentStatusSuccess(res), err => this.accountService.handleError(err));
  }
  onGetResidentStatusSuccess(res){
    this.isResident = res;
  }
  onMaintenanceClick() {
    this.router.navigate(['/maintenance/dashboard']);
  }
  onTourClick() {
    this.router.navigate(['/account/tours']);
  }
  onDashboardHomeClick() {
    this.router.navigate(['/application/dashboard']);
  }
  onLeaseClick() {
    this.router.navigate(['/leases/non-legacy-leases-dashboard']);
  }
  onRenewalClick() {
    this.router.navigate(['/renewalcog/renewal-dashboard']);
  }
  onSmartHomeClick() {
    if (this.isResident) {
      this.router.navigate(['/smarthome/devices']);
    } else {
      window.location.href = this.smartHomeMarketingUrl;
    }
  }
  onAccountClick() {
    this.router.navigate(['/account/account-management']);
  }
  onFavoritesClick() {
    this.router.navigate(['/favorites/dashboard']);
  }
  onSignOutClick() {
    localStorage.clear();
    this.router.navigate(['/logout']);
  }
  onBrokerClick = () => {
    this.router.navigate(['/broker/home']);
  }
}
